import { render } from "./ClientesDetalle.vue?vue&type=template&id=40a97bb8"
import script from "./ClientesDetalle.vue?vue&type=script&lang=js"
export * from "./ClientesDetalle.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__